/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: package-media-audio-asset-list-component.ts
 *
 * Created by randysorensen on 9/19/18.
 */

function PackageMediaAudioAssetListController(
    this: JS5Object,
    _: JS5Object,
    PackageMediaService: JS5Object,
    PackageUtilService: JS5Object
) {

    //================//
    // Template Logic //
    //================//

    this.getAudioList = (): JS5Object[] => {
        return PackageMediaService.getAssetList('Audio');
    };

    this.isVisible = () => {
        return PackageMediaService.getValidationStatus('AUDIO') !== 'NOT APPLICABLE';
    };

    this.isEnabled = () => {
        return PackageMediaService.hasMainVideo();
    };

    this.getIngestPercent = () => {
        return PackageMediaService.calculateIngestPercent(this.getAudioList());
    };

    this.getValidationStatus = () => {
        return PackageMediaService.getValidationStatus('AUDIO');
    };

    this.addNewAudio = () => {
        PackageMediaService.packageMediaData.assets.push({
            acceptTemplateMember: null,
            type: 'Audio'
        });
        PackageUtilService.editorForm.$setDirty();
    };

    this.removeAudio = (audioAsset: JS5Object) => {
        _.pull(PackageMediaService.packageMediaData.assets, audioAsset);
        PackageUtilService.editorForm.$setDirty();
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
    };
}

angular.module('prism-ui.package').component('packageMediaAudioAssetList', {
    controller: PackageMediaAudioAssetListController,
    templateUrl: 'package/editor/components/view/media/assetList/audioAssetList/package-media-audio-asset-list-template.html',
    bindings: {
    }
});
